import { History } from 'history';

export class Navigation {
    static pushExternal = (url: string, target?: string): Promise<void> => {
        return new Promise<void>((resolve) => {
            if (target) {
                window.open(url, target);
            } else {
                window.location.href = url;
            }
            resolve();
        });
    };

    static smartNavigate = (
        to: string,
        spaPath: string,
        history: History,
        target?: string
    ) => {
        if (to.toLocaleLowerCase().startsWith(spaPath)) {
            const pattern = new RegExp(spaPath, 'gi');
            history.push(to.replace(pattern, ''));
        } else {
            if (window.site) {
                window.site.go(to, target);
            } else {
                Navigation.pushExternal(to, target);
            }
        }
    };
}

const updateCart = () => {
    return new Promise<void>((resolve) => {
        window.site.updateCartCount();
        resolve();
    }).catch((err) => {
        console.log(err);
    });
};

const externalSite = {
    updateCart,
};

export default externalSite;
